import styled, { css } from "styled-components";

export const TableRowContainer = styled.div<{ length: number }>`
  display: flex;
  flex-direction: row;
  max-width: 700px;
  height: 48px;
  @media only screen and (max-width: 499px) {
    display: grid;
    ${(props) => css`
      width: calc(${props.length} * 200px);
      grid-template-columns: repeat(${props.length}, 1fr);
    `}
  }
`;

export const TableCell = styled.div<{ length: number; index: number }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-overflow: ellipsis;
  font-size: 14px;
  ${(props) => css`
    color: ${props.color};
  `}

  ${(props) =>
    props.length === 4 &&
    css`
      width: 164px;
      padding-right: 16px;
      text-align: left;
    `}

  ${(props) =>
    props.length === 3 &&
    css`
      width: 223px;
      padding-right: 16px;
      text-align: left;
    `}

  ${(props) =>
    props.length === 2 &&
    props.index === 0 &&
    css`
      width: 50%;
      text-align: left;
    `}

  ${(props) =>
    props.length === 2 &&
    props.index === 1 &&
    css`
      width: 50%;
      text-align: right;
    `}

  @media only screen and (max-width: 499px) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ${(props) =>
      props.length === 4 &&
      css`
        width: 150px;
      `}

    ${(props) =>
      props.length === 3 &&
      css`
        width: calc(100% - 8px);
      `}
  }
`;
